import type { Theme } from "@mui/material/styles";
import type { InputFieldSize } from "./sharedInputTypes";

export const getInputSizeMap = (theme: Theme): Record<InputFieldSize, string> => ({
  full: "100%",
  large: theme.inputSizes.large,
  medium: theme.inputSizes.medium,
  small: theme.inputSizes.small,
  inherit: "inherit",
  fit: "auto",
});

export const createSharedInputStyles = (
  theme: Theme,
  size: InputFieldSize | number = "medium"
) => {
  const sizeMap = getInputSizeMap(theme);
  const width =
    typeof size === "number" ? `${size}px` : sizeMap[size as InputFieldSize];

  return {
    color: "inherit",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid`,
    borderColor:
      "light-dark(var(--mui-palette-neutral-light), var(--mui-palette-neutral-dark))",
    // backgroundColor: theme.palette.background.paper,
    width,
    minHeight: "2.6em", // sadly this isn't exported from MUI
    // transition: theme.transitions.create("all"),

    "&:hover": {
      borderColor: theme.palette.grey.bold,
    },

    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      "& ::placeholder": {
        color: theme.palette.grey[600],
      },
    },

    [theme.breakpoints.up("sm")]: {
      width:
        typeof size === "number" ? `${size}px` : size === "full" ? "100%" : width,
    },

    "& .MuiInputBase-input": {
      flex: 10,
      padding: theme.spacing(1),
      fieldSizing: "content",

      "&::placeholder": {
        opacity: 0.7,
      },
    },

    "&.MuiInputBase-adornedStart .MuiInputBase-input": {
      paddingLeft: 0,
    },
  };
};
